// src/composables/useAuth.js
import { ref, onUnmounted, readonly } from 'vue';
import { auth } from '@/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

const user = ref(null);
const claims = ref(null);
const isAuthReady = ref(false);

// This function will be called by our listener, and can also be called on-demand
const refreshUserAndClaims = async (_user) => {
  if (_user) {
    const idTokenResult = await _user.getIdTokenResult(true); // 'true' forces a refresh
    user.value = _user;
    claims.value = idTokenResult.claims;
  } else {
    user.value = null;
    claims.value = null;
  }
  isAuthReady.value = true;
};

const unsubscribe = onAuthStateChanged(auth, refreshUserAndClaims);

onUnmounted(() => {
  unsubscribe();
});

// --- DEFINITIVE FIX: Create an exported function to force a token refresh ---
// This gives any component the power to ensure it has the latest auth state.
export async function forceTokenRefresh() {
  const currentUser = auth.currentUser;
  if (currentUser) {
    await refreshUserAndClaims(currentUser);
  }
}

export function useAuth() {
  return { 
    user: readonly(user), 
    claims: readonly(claims), 
    isAuthReady: readonly(isAuthReady) 
  };
}